/* ============
 * Vue-Data-Tables
 * ============
 *
 * Customizable and pageable table,
 * based on vue2 and element-ui
 *
 * https://njleonzhang.github.io/vue-data-tables/#/
 */

import Vue from 'vue'
import { DataTablesServer, DataTables } from 'vue-data-tables'

Vue.use(DataTables)
Vue.use(DataTablesServer)



// WEBPACK FOOTER //
// ./src/app/plugins/vue-datatables.js